import React from "react";
//import Todo from "./component/todoReact/todo.js";
import Temp from "./component/weather/temp";

const App = () => {
  return (
    <>
      <Temp />
    </>
  );
};

export default App;
